import { ColorConstants } from "../../../../constants";
import { createPinCanvas, PIN_BOX_SIZE, PIN_PIXEL_RATIO } from "../../../general/Map/utils";
import { DashboardMapPinColour } from "../DashboardMapProps";

/* Pin fill tones resolved from JS colour constants — no per-render DOM reads */
const PIN_COLOUR_HEX: { [colour in DashboardMapPinColour]: string } = {
  green: ColorConstants.GREEN_600,
  coral: ColorConstants.CORAL_500,
  "mint-green": ColorConstants.MINT_GREEN_600,
  goldenrod: ColorConstants.GOLDENROD_500,
  blue: ColorConstants.BLUE_500,
  "sky-blue": ColorConstants.SKY_BLUE_500,
  aqua: ColorConstants.AQUA_500,
  magenta: ColorConstants.MAGENTA_500,
  violet: ColorConstants.VIOLET_500,
  navy: ColorConstants.GREY_500,
};

/* Re-exported so the layer definition keeps reading these from here alongside the image helpers.
   The marker itself is drawn by the shared Map util, since the landholding map draws the same pin. */
export { PIN_BOX_SIZE, PIN_PIXEL_RATIO };

const PIN_RASTER_SIZE = PIN_BOX_SIZE * PIN_PIXEL_RATIO;

export const resolvePinColour = (colour: DashboardMapPinColour): string => PIN_COLOUR_HEX[colour];

export const pinImageId = (colour: DashboardMapPinColour): string => `dashboard-map-pin-${colour}`;

/* Rasterises the map-pin marker so it can be registered as a Mapbox symbol-layer image */
export const createPinImage = (colour: DashboardMapPinColour): ImageData | null => {
  const canvas = createPinCanvas(resolvePinColour(colour));
  const context = canvas?.getContext("2d");
  if (!context) return null;

  return context.getImageData(0, 0, PIN_RASTER_SIZE, PIN_RASTER_SIZE);
};
